module.exports = __webpack_public_path__ + "static/media/example-2.d2756d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Millard/example-2.jpg
// module id = 270
// module chunks = 0